(function() {
  var WARRANTY_PRODUCT_ID = 7434316742734;
  var isProcessing = false;
  var pendingUpdate = false;
  var myFetch = false;
  var isPinning = false;
  var lastCartHash = '';

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 86400000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  // Clears the care cookie entirely (expires it in the past) instead of writing
  // an explicit "false" value. This is the key fix: an explicit "false" is a
  // sticky, 7-day opt-out that survives an empty-cart moment. Clearing the
  // cookie instead means the NEXT time items are added, syncCheckboxState()'s
  // "no cookie" branch re-applies the merchant's default (settings.checkbox_true),
  // so Worry-Free Delivery can come back automatically after the cart is fully
  // emptied and refilled - which is the behavior Hieu asked for.
  function clearCareCookie() {
    setCookie('kidamento_care', '', -1);
  }

  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '=([^;]*)');
    return m ? m[2] : null;
  }

  function getPreviewParam() {
    var m = window.location.search.match(/preview_theme_id=([^&]*)/);
    return m ? '&preview_theme_id=' + m[1] : '';
  }

  var warrantyVariantsCache = null;

  function loadWarrantyVariants() {
    if (warrantyVariantsCache) return Promise.resolve(warrantyVariantsCache);
    return fetch('/products/extended-warranty.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        warrantyVariantsCache = product.variants.map(function(v) {
          return { id: v.id, price: v.price / 100 };
        });
        return warrantyVariantsCache;
      });
  }

  function findClosestVariant(cartSubtotal) {
    var perVal = document.querySelector('.per_val');
    if (!perVal || !perVal.textContent.trim()) return null;
    var pct = parseFloat(perVal.textContent.trim());
    var target = cartSubtotal * pct / 100;
    if (!warrantyVariantsCache || !warrantyVariantsCache.length) return null;
    var closest = null;
    var closestDiff = Infinity;
    warrantyVariantsCache.forEach(function(v) {
      var diff = Math.abs(v.price - target);
      if (diff < closestDiff) {
        closestDiff = diff;
        closest = { id: String(v.id), price: v.price };
      }
    });
    return closest;
  }

  function warrantyFetch(url, options) {
    myFetch = true;
    return fetch(url, options).finally(function() { myFetch = false; });
  }

  function getCartHash(cart) {
    return cart.item_count + ':' + cart.items.map(function(i) {
      return i.variant_id + '=' + i.quantity;
    }).join(',');
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  // ---- PIN WARRANTY TO TOP ----

  function pinWarrantyToTop() {
    if (isPinning) return;
    isPinning = true;
    var tbodies = document.querySelectorAll('.cart-items__table tbody');
    tbodies.forEach(function(tbody) {
      var rows = Array.from(tbody.querySelectorAll('tr.cart-items__table-row'));
      var warrantyRow = null;
      rows.forEach(function(row) {
        var titleEl = row.querySelector('.reversed-link__text');
        if (titleEl && titleEl.textContent.trim() === 'Worry-Free Delivery') {
          warrantyRow = row;
        }
      });
      if (warrantyRow) {
        var firstRow = tbody.querySelector('tr.cart-items__table-row');
        if (firstRow && firstRow !== warrantyRow) {
          tbody.insertBefore(warrantyRow, firstRow);
        }
      }
    });
    requestAnimationFrame(function() { isPinning = false; });
  }

  // ---- UPDATE WARRANTY PRICE IN SUMMARY ----

  function updateWarrantyPriceDisplay() {
    warrantyFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var warrantyItem = null;
        cart.items.forEach(function(item) {
          if (item.product_id == WARRANTY_PRODUCT_ID) warrantyItem = item;
        });
        var priceEl = document.querySelector('.warranty-price');
        if (priceEl && warrantyItem) {
          priceEl.textContent = formatMoney(warrantyItem.final_price);
        } else if (priceEl && !warrantyItem) {
          priceEl.textContent = '';
        }
      })
      .catch(function() {});
  }

  // ---- SECTION RELOAD ----

  function reloadCartSection() {
    var comp = document.querySelector('cart-items-component');
    if (!comp) return Promise.resolve();
    var sectionId = comp.getAttribute('data-section-id');
    if (!sectionId) return Promise.resolve();
    var url = window.location.pathname.split('?')[0] + '?section_id=' + sectionId + getPreviewParam();
    return fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newComp = doc.querySelector('cart-items-component');
        if (newComp) {
          var drawer = document.querySelector('cart-drawer-component');
          var dialog = document.getElementById('cart-drawer-dialog');
          var wasOpen = dialog && dialog.hasAttribute('open');
          comp.replaceWith(newComp);
          if (wasOpen && drawer && typeof drawer.showDialog === 'function') {
            drawer.showDialog();
          }
        }
        setTimeout(function() {
          syncCheckboxState();
          pinWarrantyToTop();
          updateWarrantyPriceDisplay();
        }, 50);
      });
  }

  // ---- CHECKBOX STATE ----

  function syncCheckboxState() {
    var cb = document.querySelector('.warranty-checkbox');
    if (!cb) return;
    var cookie = getCookie('kidamento_care');
    if (cookie === 'true') cb.checked = true;
    else if (cookie === 'false') cb.checked = false;
    else {
      cb.checked = (cb.getAttribute('bydefault') === 'true');
      setCookie('kidamento_care', cb.checked ? 'true' : 'false', 7);
    }
  }

  // ---- CART CHANGE HANDLER ----

  function handleCartChange() {
    if (isProcessing) {
      pendingUpdate = true;
      return;
    }

    // If the care cookie was cleared (e.g. the cart was just emptied and
    // reset by the branch below), re-resolve it against the merchant default
    // instead of silently no-op'ing. This is what lets Worry-Free Delivery
    // come back automatically once new items are added to a cart that was
    // previously emptied out.
    var careCookie = getCookie('kidamento_care');
    if (careCookie === null) {
      syncCheckboxState();
      careCookie = getCookie('kidamento_care');
    }
    if (careCookie !== 'true') return;

    isProcessing = true;

    loadWarrantyVariants().then(function() {
      return warrantyFetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var subtotal = 0;
      var existingWarrantyKey = null;
      var existingWarrantyVariantId = null;
      var nonWarrantyItems = 0;

      cart.items.forEach(function(item) {
        if (item.product_id == WARRANTY_PRODUCT_ID) {
          existingWarrantyKey = item.key;
          existingWarrantyVariantId = item.variant_id;
        } else {
          subtotal += item.final_line_price / 100;
          nonWarrantyItems++;
        }
      });

      if (nonWarrantyItems === 0) {
        if (existingWarrantyKey) {
          clearCareCookie();
          warrantyFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existingWarrantyKey, quantity: 0 })
          }).then(function() {
            isProcessing = false;
            reloadCartSection();
            if (pendingUpdate) { pendingUpdate = false; setTimeout(function() { handleCartChange(); }, 200); }
          }).catch(function() { isProcessing = false; });
        } else {
          clearCareCookie();
          isProcessing = false;
          syncCheckboxState();
        }
        return;
      }

      var variant = findClosestVariant(subtotal);
      if (!variant) { isProcessing = false; return; }

      if (existingWarrantyKey && existingWarrantyVariantId == variant.id) {
        isProcessing = false;
        pinWarrantyToTop();
        updateWarrantyPriceDisplay();
        if (pendingUpdate) { pendingUpdate = false; setTimeout(function() { handleCartChange(); }, 200); }
        return;
      }

      var doAdd = function() {
        warrantyFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variant.id), quantity: 1 }] })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('cart/add failed');
          return r.json();
        })
        .then(function() {
          isProcessing = false;
          reloadCartSection();
          if (pendingUpdate) { pendingUpdate = false; setTimeout(function() { handleCartChange(); }, 200); }
        })
        .catch(function(err) {
          console.error('[Warranty]', err);
          isProcessing = false;
        });
      };

      if (existingWarrantyKey) {
        warrantyFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: existingWarrantyKey, quantity: 0 })
        }).then(doAdd).catch(function() { isProcessing = false; });
      } else {
        doAdd();
      }
    })
    .catch(function() { isProcessing = false; });
  }

  function removeWarrantyFromCart() {
    if (isProcessing) return;
    isProcessing = true;

    warrantyFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var warrantyKey = null;
        cart.items.forEach(function(item) {
          if (item.product_id == WARRANTY_PRODUCT_ID) warrantyKey = item.key;
        });
        if (!warrantyKey) { isProcessing = false; return; }
        return warrantyFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: warrantyKey, quantity: 0 })
        });
      })
      .then(function() {
        isProcessing = false;
        reloadCartSection();
      })
      .catch(function() { isProcessing = false; });
  }

  // ---- WARRANTY CHECKBOX ----

  document.addEventListener('change', function(e) {
    if (!e.target.classList.contains('warranty-checkbox')) return;
    if (e.target.checked) {
      setCookie('kidamento_care', 'true', 7);
      handleCartChange();
    } else {
      setCookie('kidamento_care', 'false', 7);
      removeWarrantyFromCart();
    }
  });

  // ---- WARRANTY TOOLTIP ----

  document.addEventListener('click', function(e) {
    if (e.target.closest('.tooltip_icon_img')) {
      var w = document.querySelector('.tooltip-content-wrapper');
      if (w) w.classList.add('active');
    }
    if (e.target.closest('.tooltip-content-wrapper .cross-icon')) {
      var w = document.querySelector('.tooltip-content-wrapper');
      if (w) w.classList.remove('active');
    }
    var w = document.querySelector('.tooltip-content-wrapper');
    if (w && e.target === w) w.classList.remove('active');
  });

    // ---- WFD REMOVE BUTTON ----
  // When user clicks Remove on the WFD cart item, uncheck the checkbox
  // and set the cookie to false so it doesn't get re-added.
  // (This IS an explicit opt-out by the user, so it stays a hard "false" -
  // unlike the empty-cart case above, which is not a deliberate opt-out.)

  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('.cart-items__remove-button');
    if (!removeBtn) return;
    var row = removeBtn.closest('tr.cart-items__table-row');
    if (!row) return;
    var titleEl = row.querySelector('.reversed-link__text');
    if (titleEl && titleEl.textContent.trim() === 'Worry-Free Delivery') {
      setCookie('kidamento_care', 'false', 7);
      syncCheckboxState();
      lastCartHash = '';
    }
  });

  // ---- DRAWER POLLING ----
  // Every 1.5s, if the cart drawer is open, fetch /cart.js.
  // If the cart changed since last check, recalculate warranty and pin to top.
  // This catches ALL sources: Candy Rack, theme morph, fetch, XHR, anything.

  setInterval(function() {
    var dialog = document.getElementById('cart-drawer-dialog');
    if (!dialog || !dialog.hasAttribute('open')) return;
    if (isProcessing || myFetch) return;

    syncCheckboxState();
    pinWarrantyToTop();

    // Read the cookie AFTER syncCheckboxState(), since sync may have just
    // resolved a cleared cookie into a fresh default value.
    var cookie = getCookie('kidamento_care');
    if (cookie !== 'true') return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var hash = getCartHash(cart);
        if (hash !== lastCartHash) {
          lastCartHash = hash;
          handleCartChange();
        }
      })
      .catch(function() {});
  }, 1500);

  // ---- FETCH INTERCEPTOR (for immediate response on normal add-to-cart) ----

  var debounceTimer = null;
  var nativeFetch = Window.prototype.fetch.bind(window);
  window.fetch = function() {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url || '');
    var result = nativeFetch.apply(this, arguments);
    if (!myFetch) {
      var isCartMutation = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/add') !== -1;
      if (isCartMutation) {
        result.then(function() {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function() {
            handleCartChange();
          }, 800);
        });
      }
    }
    return result;
  };

  // ---- XHR INTERCEPTOR (catches apps like Candy Rack that may use XHR) ----

  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._warrantyUrl = typeof url === 'string' ? url : '';
    return origXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    var xhr = this;
    var url = xhr._warrantyUrl || '';
    if (!myFetch) {
      var isCartMutation = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/add') !== -1;
      if (isCartMutation) {
        xhr.addEventListener('load', function() {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function() {
            handleCartChange();
          }, 800);
        });
      }
    }
    return origXHRSend.apply(this, arguments);
  };

  // ---- INITIAL STATE ----

  function verifyWarrantyState() {
    loadWarrantyVariants().then(function() {
      return warrantyFetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var hasWarranty = cart.items.some(function(i) { return i.product_id == WARRANTY_PRODUCT_ID; });
      var hasOtherItems = cart.items.some(function(i) { return i.product_id != WARRANTY_PRODUCT_ID; });
      var cookie = getCookie('kidamento_care');
      lastCartHash = getCartHash(cart);

      if (cookie === 'true' && !hasWarranty && hasOtherItems) {
        handleCartChange();
      } else if (cookie === 'true' && !hasWarranty && !hasOtherItems) {
        clearCareCookie();
        syncCheckboxState();
      } else if (cookie === 'true' && hasWarranty) {
        handleCartChange();
      }
    })
    .catch(function() {});
  }

  document.addEventListener('DOMContentLoaded', function() {
    syncCheckboxState();
    setTimeout(verifyWarrantyState, 1000);
  });


  // ===================== FBT =====================

  document.addEventListener('click', function(e) {
    var card = e.target.closest('.product-card--bought-together');
    if (!card) return;
    if (e.target.closest('select, option, .select, button')) return;
    e.preventDefault();
    e.stopPropagation();
    var checkbox = card.querySelector('.product-bought-together__checkbox');
    if (!checkbox || checkbox.disabled) return;
    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    card.classList.toggle('fbt-selected', checkbox.checked);
    var comp = card.closest('products-bought-together');
    if (comp) fbtUpdateSubtotal(comp);
  });

  function fbtUpdateSubtotal(comp) {
    var mainPrice = parseInt(comp.dataset.mainProductPrice || '0', 10);
    var mainComparePrice = parseInt(comp.dataset.mainComparePrice || '0', 10);
    var subTotalEl = comp.querySelector('[ref="subTotal"]');
    var itemCountEl = comp.querySelector('[ref="itemCount"]');
    var compareEl = comp.querySelector('[ref="compareSubTotal"]');
    if (!subTotalEl) return;

    var bundleTotal = 0;
    var bundleCompareTotal = 0;
    var checkedCount = 0;
    var hasDiscount = mainComparePrice > mainPrice;

    comp.querySelectorAll('.product-bought-together__checkbox:checked').forEach(function(cb) {
      var card = cb.closest('.product-card--bought-together');
      if (!card) return;
      var sel = card.querySelector('select[name="id"]');
      if (sel && sel.selectedOptions[0]) {
        var itemPrice = parseInt(sel.selectedOptions[0].dataset.price || '0', 10);
        var itemCompare = parseInt(sel.selectedOptions[0].dataset.compareAtPrice || '0', 10);
        bundleTotal += itemPrice;
        bundleCompareTotal += itemCompare > itemPrice ? itemCompare : itemPrice;
        if (itemCompare > itemPrice) hasDiscount = true;
        checkedCount++;
      }
    });

    var total = mainPrice + bundleTotal;
    var compareTotal = (mainComparePrice > mainPrice ? mainComparePrice : mainPrice) + bundleCompareTotal;
    var count = checkedCount + (mainPrice > 0 ? 1 : 0);

    var fmt = (window.Shopify && Shopify.formatMoney)
      ? function(v) { return Shopify.formatMoney(v); }
      : function(v) { return '$' + (v / 100).toFixed(2); };

    subTotalEl.textContent = fmt(total);

    if (compareEl) {
      if (hasDiscount && compareTotal > total) {
        compareEl.textContent = fmt(compareTotal);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (itemCountEl) {
      itemCountEl.textContent = '(' + count + (count === 1 ? ' item' : ' items') + ')';
    }
  }

  function initFBT() {
    document.querySelectorAll('products-bought-together').forEach(function(comp) {
      var mainVariantId = comp.dataset.mainVariantId;
      var origBtn = comp.querySelector('[ref="addAllToCart"]');
      if (!origBtn) return;

      var addBtn = origBtn.cloneNode(true);
      addBtn.removeAttribute('on:click');
      addBtn.removeAttribute('ref');
      addBtn.disabled = false;
      origBtn.parentNode.replaceChild(addBtn, origBtn);

      comp.querySelectorAll('.product-card--bought-together').forEach(function(card) {
        var cb = card.querySelector('.product-bought-together__checkbox');
        if (cb && cb.checked) card.classList.add('fbt-selected');
      });

      comp.addEventListener('change', function(e) {
        if (e.target.classList.contains('product-bought-together__checkbox')) {
          fbtUpdateSubtotal(comp);
        }
      });

      addBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var items = [];
        if (mainVariantId) {
          items.push({ id: parseInt(mainVariantId), quantity: 1 });
        }
        comp.querySelectorAll('.product-bought-together__checkbox:checked').forEach(function(cb) {
          var card = cb.closest('.product-card--bought-together');
          if (!card) return;
          var sel = card.querySelector('select[name="id"]');
          if (sel) items.push({ id: parseInt(sel.value), quantity: 1 });
        });

        if (items.length === 0) return;

        addBtn.classList.add('btn--loading');
        addBtn.disabled = true;
        myFetch = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(r) {
          myFetch = false;
          if (!r.ok) throw new Error('Failed: ' + r.status);
          return r.json();
        })
        .then(function() {
          addBtn.classList.remove('btn--loading');
          addBtn.disabled = false;

          var cartComp = document.querySelector('cart-items-component');
          var sectionId = cartComp ? cartComp.getAttribute('data-section-id') : null;
          var drawer = document.querySelector('cart-drawer-component');

          if (sectionId && drawer) {
            var sectionUrl = window.location.pathname.split('?')[0] + '?section_id=' + sectionId + getPreviewParam();
            fetch(sectionUrl)
              .then(function(r) { return r.text(); })
              .then(function(html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var newComp = doc.querySelector('cart-items-component');
                if (newComp && cartComp) cartComp.replaceWith(newComp);
                if (typeof drawer.showDialog === 'function') {
                  drawer.showDialog();
                }
                setTimeout(function() {
                  syncCheckboxState();
                  pinWarrantyToTop();
                  handleCartChange();
                }, 500);
              });
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function(err) {
          myFetch = false;
          console.error('[FBT]', err);
          addBtn.classList.remove('btn--loading');
          addBtn.disabled = false;
        });
      });

      setTimeout(function() { fbtUpdateSubtotal(comp); }, 500);
    });
  }

  document.addEventListener('DOMContentLoaded', initFBT);

  document.addEventListener('DOMContentLoaded', function() {
  // Wishlist button (desktop header icon)
  const wishlistBtn = document.querySelector('a.wishlist-button');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function() {
      if (typeof gtag === 'function') {
        gtag('event', 'wishlist_click', {
          event_category: 'engagement',
          event_label: 'header_wishlist_button'
        });
      }
    });
  }

  // Search button — mobile (menu drawer)
  const mobileSearchBtn = document.querySelector('#menu-drawer-dialog .menu-drawer__search-btn');
  if (mobileSearchBtn) {
    mobileSearchBtn.addEventListener('click', function() {
      if (typeof gtag === 'function') {
        gtag('event', 'search_open', {
          event_category: 'engagement',
          event_label: 'mobile_search_button'
        });
      }
    });
  }

  // Search input — desktop (opens predictive results on typing)
  const desktopSearchInput = document.querySelector('#SearchInput-sections--21015521689678__header');
  if (desktopSearchInput) {
    let searchOpenFired = false;
    desktopSearchInput.addEventListener('input', function() {
      if (!searchOpenFired && this.value.trim().length > 0 && typeof gtag === 'function') {
        gtag('event', 'search_open', {
          event_category: 'engagement',
          event_label: 'desktop_search'
        });
        searchOpenFired = true;
      }
      if (this.value.trim().length === 0) {
        searchOpenFired = false;
      }
    });
  }
});
})();
